import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHryvnia = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 40.000000 40.000000",
	preserveAspectRatio: "xMidYMid meet",
	width: "1em",
	height: "1em",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		transform: "translate(0.000000,40.000000) scale(0.100000,-0.100000)",
		fill: "currentColor",
		stroke: "none",
		children: /* @__PURE__ */ _jsx("path", { d: "M65 391 c-11 -5 -29 -19 -40 -31 -18 -20 -20 -36 -20 -161 0 -138 0 -139 28 -166 27 -28 28 -28 167 -28 139 0 140 0 167 28 28 27 28 28 28 167 0 139 0 140 -28 167 -27 27 -30 28 -155 30 -70 2 -136 -1 -147 -6z m189 -97 c9 -8 16 -24 16 -34 0 -10 2 -25 5 -32 4 -9 -5 -18 -22 -25 l-28 -11 28 -1 c48 -2 29 -20 -25 -23 -54 -3 -72 -20 -40 -37 12 -7 31 -7 51 -1 27 7 31 6 31 -10 0 -21 -19 -30 -68 -30 -42 0 -72 24 -72 57 0 12 -4 23 -10 23 -5 0 -10 5 -10 10 0 6 9 10 19 10 11 0 23 5 26 10 3 6 -3 10 -14 10 -11 0 -23 5 -26 10 -4 6 15 10 49 10 58 0 70 7 60 35 -6 14 -15 16 -44 11 -28 -4 -39 -2 -43 8 -7 18 7 24 60 25 25 1 48 -5 57 -15z" })
	})
});
export default SvgHryvnia;
